import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Link } from "react-router-dom";

const CATEGORIES = []; // will be loaded

export default function Admin() {
  const [tab, setTab] = useState("stats");
  const [stats, setStats] = useState(null);
  const [listings, setListings] = useState([]);
  const [users, setUsers] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [xml, setXml] = useState("");
  const [importing, setImporting] = useState(false);
  const [migrating, setMigrating] = useState(false);
  const [linking, setLinking] = useState(false);
  const [migResult, setMigResult] = useState(null);
  const [linkResult, setLinkResult] = useState(null);
  const [search, setSearch] = useState("");
  const [showCreate, setShowCreate] = useState(false);
  const [subModal, setSubModal] = useState(null); // {user}
  const [newListing, setNewListing] = useState({ title: "", category_slug: "", description: "", city: "", region: "", user_email: "", contact_email: "", contact_phone: "", whatsapp: "", website: "", status: "active", photos: [] });

  useEffect(() => { refresh(); }, []);
  const refresh = async () => {
    try {
      const [s, l, u, t, c] = await Promise.all([
        api.get("/admin/stats"),
        api.get("/admin/listings"),
        api.get("/admin/users"),
        api.get("/admin/transactions"),
        api.get("/categories"),
      ]);
      setStats(s.data); setListings(l.data); setUsers(u.data); setTransactions(t.data); setCategories(c.data);
    } catch { toast.error("Errore caricamento dati"); }
  };

  const setListingStatus = async (id, status) => {
    try { await api.put(`/admin/listings/${id}/status`, { status }); toast.success(`Stato: ${status}`); refresh(); }
    catch { toast.error("Errore"); }
  };
  const toggleFeatured = async (id, featured) => {
    try { await api.put(`/admin/listings/${id}/feature`, { featured }); toast.success(featured ? "In evidenza" : "Rimosso"); refresh(); }
    catch { toast.error("Errore"); }
  };
  const delListing = async (id) => {
    if (!window.confirm("Eliminare definitivamente l'annuncio?")) return;
    try { await api.delete(`/admin/listings/${id}`); toast.success("Annuncio eliminato"); refresh(); }
    catch { toast.error("Errore"); }
  };
  const delUser = async (id) => {
    if (!window.confirm("Cancellare utente e tutti i suoi annunci?")) return;
    try { await api.delete(`/admin/users/${id}?delete_listings=true`); toast.success("Utente cancellato"); refresh(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const changeRole = async (id, role) => {
    try { await api.put(`/admin/users/${id}/role`, { role }); toast.success(`Ruolo: ${role}`); refresh(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  const sendResetLink = async (id) => {
    try {
      const { data } = await api.post(`/admin/users/${id}/send-reset-link`);
      toast.success(data.email_sent ? "Email inviata" : "Link generato (email stub)");
      if (!data.email_sent) navigator.clipboard?.writeText(data.link).then(() => toast.info("Link copiato negli appunti"));
    } catch { toast.error("Errore"); }
  };

  const cancelSub = async (userId) => {
    if (!window.confirm("Cancellare abbonamento e disattivare annunci?")) return;
    try { await api.put(`/admin/users/${userId}/subscription`, { cancel: true }); toast.success("Abbonamento cancellato"); refresh(); setSubModal(null); }
    catch { toast.error("Errore"); }
  };
  const updateSub = async () => {
    if (!subModal) return;
    try {
      await api.put(`/admin/users/${subModal.user.id}/subscription`, {
        tier: subModal.tier || subModal.user.subscription?.tier,
        cycle: subModal.cycle || subModal.user.subscription?.cycle || "monthly",
        expires_at: subModal.expires_at || subModal.user.subscription?.expires_at,
      });
      toast.success("Abbonamento aggiornato");
      setSubModal(null); refresh();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  const readFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const r = new FileReader(); r.onload = () => setXml(r.result); r.readAsText(f);
  };
  const importXml = async () => {
    if (!xml.trim()) { toast.error("Carica o incolla un XML"); return; }
    setImporting(true);
    try {
      const { data } = await api.post("/admin/import-wp-xml", { xml_content: xml });
      toast.success(`Importati: ${data.imported} · Aggiornati: ${data.updated}`);
      refresh();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore import"); }
    finally { setImporting(false); }
  };
  const runMigratePhotos = async () => {
    setMigrating(true); setMigResult(null);
    try {
      const { data } = await api.post("/admin/migrate-photos", {}, { timeout: 1800000 });
      setMigResult(data); toast.success(`Migrate ${data.migrated_photos} foto`); refresh();
    } catch (e) { toast.error("Errore migrazione"); }
    finally { setMigrating(false); }
  };
  const runLinkAuthors = async () => {
    setLinking(true); setLinkResult(null);
    try {
      const { data } = await api.post("/admin/link-authors", {});
      setLinkResult(data); toast.success(`${data.users_created} utenti creati`); refresh();
    } catch (e) { toast.error("Errore link autori"); }
    finally { setLinking(false); }
  };

  const createListing = async (e) => {
    e.preventDefault();
    if (!newListing.title || !newListing.category_slug) { toast.error("Titolo e categoria richiesti"); return; }
    try {
      const payload = { ...newListing };
      if (!payload.user_email) delete payload.user_email;
      if (!payload.contact_email) delete payload.contact_email;
      await api.post("/admin/listings", payload);
      toast.success("Annuncio creato");
      setShowCreate(false);
      setNewListing({ title: "", category_slug: "", description: "", city: "", region: "", user_email: "", contact_email: "", contact_phone: "", whatsapp: "", website: "", status: "active", photos: [] });
      refresh();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };

  const filteredUsers = users.filter((u) => !search || u.email.toLowerCase().includes(search.toLowerCase()) || (u.name || "").toLowerCase().includes(search.toLowerCase()));
  const filteredListings = listings.filter((l) => !search || l.title.toLowerCase().includes(search.toLowerCase()) || (l.city || "").toLowerCase().includes(search.toLowerCase()) || (l.author_name || "").toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10" data-testid="admin-page">
      <header className="mb-8">
        <div className="text-xs uppercase tracking-[0.3em] text-[#E619A8] mb-2">· Admin</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl">Pannello di controllo</h1>
      </header>

      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
          {[
            ["Utenti", stats.users, "#FFBE00"],
            ["Annunci", stats.listings, "#FFBE00"],
            ["Attivi", stats.active_listings, "#22C55E"],
            ["Transazioni", stats.paid_transactions, "#E619A8"],
            ["Ricavi", `€${stats.revenue_eur}`, "#E619A8"],
          ].map(([l, v, c]) => (
            <div key={l} className="hm-card p-4">
              <div className="text-xs uppercase tracking-widest text-zinc-500">{l}</div>
              <div className="font-heading font-black text-2xl mt-1" style={{ color: c }}>{v}</div>
            </div>
          ))}
        </div>
      )}

      <div className="flex gap-1 mb-5 border-b border-zinc-800 overflow-x-auto">
        {[
          ["stats", "Dashboard"],
          ["listings", "Annunci"],
          ["users", "Utenti"],
          ["transactions", "Transazioni"],
          ["featured", "Home Spotlight"],
          ["waitlist", "Waitlist"],
          ["incomplete", "Pagamenti incompleti"],
          ["import", "Import WP"],
          ["migrate", "Migrazione"],
        ].map(([t, l]) => (
          <button key={t} onClick={() => setTab(t)} className={`px-4 py-2 text-xs uppercase tracking-wider whitespace-nowrap ${tab === t ? "text-[#FFBE00] border-b-2 border-[#FFBE00]" : "text-zinc-500"}`} data-testid={`admin-tab-${t}`}>
            {l}
          </button>
        ))}
      </div>

      {(tab === "listings" || tab === "users") && (
        <div className="mb-4 flex items-center gap-3">
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Cerca…" className="flex-1 max-w-sm bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" data-testid="admin-search" />
          {tab === "listings" && (
            <button onClick={() => setShowCreate(true)} className="px-4 py-2 rounded-md bg-[#FFBE00] text-black font-bold uppercase text-xs tracking-wider hover:bg-[#E619A8] hover:text-white" data-testid="admin-new-listing-btn">
              <i className="fas fa-plus mr-2"></i>Nuovo annuncio
            </button>
          )}
        </div>
      )}

      {tab === "stats" && stats && (
        <div className="grid md:grid-cols-2 gap-4">
          <div className="hm-card p-6">
            <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-3">· Breakdown annunci</div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span>Totale</span><span className="font-bold">{stats.listings}</span></div>
              <div className="flex justify-between"><span>Attivi</span><span className="font-bold text-[#22C55E]">{stats.active_listings}</span></div>
              <div className="flex justify-between"><span>Non attivi</span><span className="font-bold text-zinc-500">{stats.listings - stats.active_listings}</span></div>
            </div>
          </div>
          <div className="hm-card p-6">
            <div className="text-xs uppercase tracking-widest text-[#E619A8] mb-3">· Ricavi</div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span>Transazioni pagate</span><span className="font-bold">{stats.paid_transactions}</span></div>
              <div className="flex justify-between"><span>Ricavi totali</span><span className="font-bold text-[#FFBE00]">€{stats.revenue_eur}</span></div>
            </div>
          </div>
        </div>
      )}

      {tab === "listings" && (
        <div className="space-y-2">
          <div className="text-xs text-zinc-500 mb-2">{filteredListings.length} di {listings.length}</div>
          {filteredListings.map((l) => (
            <div key={l.id} className="hm-card p-4 flex flex-wrap items-center gap-3" data-testid={`admin-listing-${l.id}`}>
              <div className="flex-1 min-w-[220px]">
                <div className="font-bold">{l.title}</div>
                <div className="text-xs text-zinc-500">{l.category_name} · {l.city || "—"} · {l.author_name}</div>
              </div>
              <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${l.status === "active" ? "bg-[#22C55E]/20 text-[#22C55E]" : "bg-zinc-800 text-zinc-400"}`}>{l.status}</span>
              <div className="flex gap-1 flex-wrap">
                <Link to={`/annunci/${l.id}`} className="px-2 py-1 text-xs uppercase border border-zinc-700 rounded hover:border-[#FFBE00] hover:text-[#FFBE00]">Vedi</Link>
                <select value={l.status} onChange={(e) => setListingStatus(l.id, e.target.value)} className="bg-[#0A0A0A] border border-zinc-800 text-xs rounded px-2 py-1">
                  <option value="draft">draft</option><option value="active">active</option><option value="inactive">inactive</option><option value="archived">archived</option>
                </select>
                <button onClick={() => toggleFeatured(l.id, !l.featured)} className={`text-xs uppercase px-2 py-1 rounded ${l.featured ? "bg-[#FFBE00] text-black" : "border border-zinc-700"}`}>{l.featured ? "★" : "☆"}</button>
                <button onClick={() => delListing(l.id)} className="text-xs uppercase px-2 py-1 rounded border border-red-900 text-red-400 hover:border-red-500 hover:text-red-500" data-testid={`admin-delete-listing-${l.id}`}>
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "users" && (
        <div className="space-y-2">
          <div className="text-xs text-zinc-500 mb-2">{filteredUsers.length} di {users.length}</div>
          {filteredUsers.map((u) => (
            <div key={u.id} className="hm-card p-4 flex flex-wrap items-center gap-3" data-testid={`admin-user-${u.id}`}>
              <div className="flex-1 min-w-[200px]">
                <div className="font-bold flex items-center gap-2">{u.name} {u.email_verified ? <i className="fas fa-circle-check text-[#22C55E] text-xs" title="Email verificata"></i> : <i className="fas fa-circle-exclamation text-zinc-500 text-xs" title="Non verificata"></i>}</div>
                <div className="text-xs text-zinc-500">{u.email} · {u.listings_count || 0} annunci {u.imported && <span className="text-[#E619A8]">· importato</span>}</div>
              </div>
              <span className={`text-[10px] uppercase tracking-wider px-2 py-1 rounded ${u.role === "admin" ? "bg-[#E619A8]/20 text-[#E619A8]" : "bg-zinc-800 text-zinc-400"}`}>{u.role}</span>
              {u.subscription ? (
                <button onClick={() => setSubModal({ user: u })} className="text-[10px] uppercase px-2 py-1 rounded bg-[#FFBE00]/20 text-[#FFBE00] hover:bg-[#FFBE00] hover:text-black" data-testid={`admin-sub-${u.id}`}>
                  {u.subscription.tier} · {u.subscription.cycle}
                </button>
              ) : (
                <button onClick={() => setSubModal({ user: u, tier: "standard", cycle: "yearly", expires_at: new Date(Date.now()+365*24*3600*1000).toISOString() })} className="text-[10px] uppercase px-2 py-1 rounded border border-zinc-700 hover:border-[#FFBE00] hover:text-[#FFBE00]">+ abbonamento</button>
              )}
              <div className="flex gap-1 flex-wrap">
                <button onClick={() => sendResetLink(u.id)} className="text-xs uppercase px-2 py-1 rounded border border-zinc-700 hover:border-[#E619A8] hover:text-[#E619A8]" title="Invia link reset password" data-testid={`admin-reset-${u.id}`}>
                  <i className="fas fa-key"></i>
                </button>
                <button onClick={() => changeRole(u.id, u.role === "admin" ? "user" : "admin")} className="text-xs uppercase px-2 py-1 rounded border border-zinc-700 hover:border-[#FFBE00] hover:text-[#FFBE00]" title="Cambia ruolo">
                  <i className={`fas ${u.role === "admin" ? "fa-user-minus" : "fa-user-shield"}`}></i>
                </button>
                <button onClick={() => delUser(u.id)} className="text-xs uppercase px-2 py-1 rounded border border-red-900 text-red-400 hover:border-red-500 hover:text-red-500" title="Cancella utente" data-testid={`admin-del-user-${u.id}`}>
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "transactions" && (
        <div className="space-y-2">
          {transactions.length === 0 && <div className="hm-card p-8 text-center text-zinc-500 text-sm">Nessuna transazione.</div>}
          {transactions.map((t) => (
            <div key={t.session_id} className="hm-card p-4 flex flex-wrap items-center gap-3 text-sm">
              <div className="flex-1 min-w-[200px]">
                <div className="font-bold">€{t.amount} · {t.tier} {t.cycle}</div>
                <div className="text-xs text-zinc-500">{t.user_email} · {new Date(t.created_at).toLocaleString("it-IT")}</div>
              </div>
              <span className={`text-[10px] uppercase px-2 py-1 rounded ${t.payment_status === "paid" ? "bg-[#22C55E]/20 text-[#22C55E]" : "bg-zinc-800 text-zinc-400"}`}>{t.payment_status}</span>
            </div>
          ))}
        </div>
      )}

      {tab === "featured" && <FeaturedSlotsPanel />}
      {tab === "waitlist" && <WaitlistPanel />}
      {tab === "incomplete" && <IncompleteSubsPanel />}

      {tab === "import" && (
        <div className="hm-card p-6">
          <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-4">· Import da WordPress (WXR XML)</div>
          <p className="text-sm text-zinc-400 mb-4">Carica il file XML esportato. Gli annunci vengono importati o aggiornati via wp_post_id.</p>
          <input type="file" accept=".xml,text/xml" onChange={readFile} className="block mb-4 text-sm" data-testid="admin-import-file" />
          <textarea value={xml} onChange={(e) => setXml(e.target.value)} rows={8} placeholder="Oppure incolla XML qui…" className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-xs font-mono" data-testid="admin-import-textarea" />
          <button onClick={importXml} disabled={importing} className="mt-4 px-5 py-3 bg-[#E619A8] text-white font-bold uppercase tracking-wider text-sm rounded-md disabled:opacity-50" data-testid="admin-import-btn">
            {importing ? "Importazione…" : "Importa"}
          </button>
        </div>
      )}

      {tab === "migrate" && (
        <div className="space-y-4">
          <div className="hm-card p-6">
            <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-3">· 1. Migra foto su object storage</div>
            <p className="text-sm text-zinc-400 mb-4">Scarica le foto degli annunci importati dal vecchio WordPress e le ri-ospita su object storage. Idempotente.</p>
            <button onClick={runMigratePhotos} disabled={migrating} className="px-5 py-3 bg-[#FFBE00] text-black font-bold uppercase tracking-wider text-sm rounded-md disabled:opacity-50" data-testid="admin-migrate-photos-btn">
              {migrating ? "Migrazione in corso…" : "Avvia migrazione foto"}
            </button>
            {migResult && <div className="mt-3 text-xs text-zinc-400">✓ Migrate: <span className="text-[#22C55E] font-bold">{migResult.migrated_photos}</span> · Fallite: <span className="text-red-400 font-bold">{migResult.failed}</span> · Annunci: <span className="text-[#FFBE00] font-bold">{migResult.listings_updated}</span></div>}
          </div>
          <div className="hm-card p-6">
            <div className="text-xs uppercase tracking-widest text-[#E619A8] mb-3">· 2. Collega autori + abbonamento migrazione</div>
            <p className="text-sm text-zinc-400 mb-4">Crea utenti dagli annunci importati e assegna abbonamento fino al <strong className="text-[#FFBE00]">30 giugno 2027</strong>. Idempotente.</p>
            <button onClick={runLinkAuthors} disabled={linking} className="px-5 py-3 bg-[#E619A8] text-white font-bold uppercase tracking-wider text-sm rounded-md disabled:opacity-50" data-testid="admin-link-authors-btn">
              {linking ? "Collegamento…" : "Collega autori"}
            </button>
            {linkResult && <div className="mt-3 text-xs text-zinc-400">✓ Creati: <span className="text-[#22C55E] font-bold">{linkResult.users_created}</span> · Collegati: <span className="text-[#FFBE00] font-bold">{linkResult.listings_linked}</span> · Abbonamenti: <span className="text-[#E619A8] font-bold">{linkResult.users_granted_subscription}</span></div>}
          </div>
        </div>
      )}

      {/* CREATE LISTING MODAL */}
      {showCreate && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setShowCreate(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={createListing} className="hm-card p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto space-y-3" data-testid="admin-create-modal">
            <div className="text-xs uppercase tracking-widest text-[#FFBE00]">· Nuovo annuncio (admin)</div>
            <input required placeholder="Titolo *" value={newListing.title} onChange={(e) => setNewListing({ ...newListing, title: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" data-testid="admin-create-title" />
            <select required value={newListing.category_slug} onChange={(e) => setNewListing({ ...newListing, category_slug: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" data-testid="admin-create-cat">
              <option value="">Categoria *</option>
              {categories.map((c) => <option key={c.slug} value={c.slug}>{c.name} · {c.tier}</option>)}
            </select>
            <textarea rows={4} placeholder="Descrizione" value={newListing.description} onChange={(e) => setNewListing({ ...newListing, description: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
            <div className="grid grid-cols-2 gap-2">
              <input placeholder="Città" value={newListing.city} onChange={(e) => setNewListing({ ...newListing, city: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
              <input placeholder="Regione" value={newListing.region} onChange={(e) => setNewListing({ ...newListing, region: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
              <input type="email" placeholder="Email contatto" value={newListing.contact_email} onChange={(e) => setNewListing({ ...newListing, contact_email: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
              <input placeholder="Telefono" value={newListing.contact_phone} onChange={(e) => setNewListing({ ...newListing, contact_phone: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
              <input placeholder="WhatsApp +39..." value={newListing.whatsapp} onChange={(e) => setNewListing({ ...newListing, whatsapp: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
              <input placeholder="Sito web" value={newListing.website} onChange={(e) => setNewListing({ ...newListing, website: e.target.value })} className="bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
            </div>
            <input type="email" placeholder="Assegna a utente (email). Vuoto = admin" value={newListing.user_email} onChange={(e) => setNewListing({ ...newListing, user_email: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
            <select value={newListing.status} onChange={(e) => setNewListing({ ...newListing, status: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm">
              <option value="active">active</option><option value="draft">draft</option><option value="inactive">inactive</option>
            </select>
            <div className="flex gap-2 justify-end pt-2">
              <button type="button" onClick={() => setShowCreate(false)} className="px-4 py-2 border border-zinc-700 rounded-md text-xs uppercase">Annulla</button>
              <button type="submit" className="px-4 py-2 bg-[#E619A8] text-white text-xs font-bold uppercase rounded-md" data-testid="admin-create-submit">Crea</button>
            </div>
          </form>
        </div>
      )}

      {/* SUBSCRIPTION MODAL */}
      {subModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setSubModal(null)}>
          <div onClick={(e) => e.stopPropagation()} className="hm-card p-6 max-w-md w-full space-y-3" data-testid="admin-sub-modal">
            <div className="text-xs uppercase tracking-widest text-[#FFBE00]">· Gestisci abbonamento</div>
            <div className="text-sm text-zinc-400">{subModal.user.name} · {subModal.user.email}</div>
            <select value={subModal.tier || subModal.user.subscription?.tier || ""} onChange={(e) => setSubModal({ ...subModal, tier: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm">
              <option value="">Tier…</option><option value="basic">basic</option><option value="standard">standard</option><option value="premium">premium</option>
            </select>
            <select value={subModal.cycle || subModal.user.subscription?.cycle || "monthly"} onChange={(e) => setSubModal({ ...subModal, cycle: e.target.value })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm">
              <option value="monthly">monthly</option><option value="yearly">yearly</option>
            </select>
            <label className="text-xs text-zinc-500">Scadenza</label>
            <input type="date" value={(subModal.expires_at || subModal.user.subscription?.expires_at || "").substring(0, 10)} onChange={(e) => setSubModal({ ...subModal, expires_at: `${e.target.value}T23:59:59+00:00` })} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-3 py-2 text-sm" />
            <div className="flex gap-2 justify-between pt-2">
              {subModal.user.subscription && <button onClick={() => cancelSub(subModal.user.id)} className="px-4 py-2 text-xs uppercase bg-red-600 text-white rounded-md" data-testid="admin-sub-cancel">Cancella</button>}
              <div className="flex gap-2 ml-auto">
                <button onClick={() => setSubModal(null)} className="px-4 py-2 border border-zinc-700 rounded-md text-xs uppercase">Chiudi</button>
                <button onClick={updateSub} className="px-4 py-2 bg-[#E619A8] text-white text-xs font-bold uppercase rounded-md" data-testid="admin-sub-save">Salva</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================================ Featured Slots Panel
function FeaturedSlotsPanel() {
  const [slots, setSlots] = useState([]);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [s, st] = await Promise.all([
        api.get("/admin/featured/slots"),
        api.get("/featured/status"),
      ]);
      setSlots(s.data);
      setStatus(st.data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const runReminders = async () => {
    try {
      await api.post("/admin/featured/reminders/run");
      toast.success("Reminder T-1 inviati");
    } catch { toast.error("Errore"); }
  };
  const runExpire = async () => {
    try {
      await api.post("/admin/featured/expire/run");
      toast.success("Job expiry eseguito");
      load();
    } catch { toast.error("Errore"); }
  };

  const statusColor = (s) => s === "active" ? "bg-[#22C55E]/20 text-[#22C55E]" :
    s === "expired" ? "bg-zinc-800 text-zinc-400" :
    s === "pending_payment" ? "bg-[#FFBE00]/20 text-[#FFBE00]" :
    s === "refund_pending" ? "bg-red-950 text-red-400" : "bg-zinc-800 text-zinc-400";

  return (
    <div className="space-y-4" data-testid="admin-featured-panel">
      <div className="hm-card p-6 grid md:grid-cols-4 gap-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Slot totali</div>
          <div className="font-heading font-black text-3xl">{status?.total_slots ?? "—"}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Attivi</div>
          <div className="font-heading font-black text-3xl text-[#E619A8]">{status?.active ?? "—"}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Disponibili</div>
          <div className="font-heading font-black text-3xl text-[#FFBE00]">{status?.available ?? "—"}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Waitlist</div>
          <div className="font-heading font-black text-3xl">{status?.waitlist_count ?? "—"}</div>
        </div>
      </div>

      <div className="flex gap-2 flex-wrap">
        <button onClick={runReminders} className="px-4 py-2 text-xs uppercase tracking-wider border border-[#FFBE00] text-[#FFBE00] rounded-md hover:bg-[#FFBE00] hover:text-black" data-testid="admin-featured-run-reminders">
          <i className="fas fa-bell mr-1"></i> Invia reminder T-1
        </button>
        <button onClick={runExpire} className="px-4 py-2 text-xs uppercase tracking-wider border border-[#E619A8] text-[#E619A8] rounded-md hover:bg-[#E619A8] hover:text-white" data-testid="admin-featured-run-expire">
          <i className="fas fa-hourglass-end mr-1"></i> Esegui job scadenza
        </button>
        <button onClick={load} className="px-4 py-2 text-xs uppercase tracking-wider border border-zinc-700 rounded-md hover:border-white" data-testid="admin-featured-refresh">
          <i className="fas fa-rotate mr-1"></i> Aggiorna
        </button>
      </div>

      {loading && <div className="text-sm text-zinc-500">Caricamento…</div>}
      {!loading && slots.length === 0 && (
        <div className="hm-card p-8 text-center text-zinc-500 text-sm">Nessuno slot featured registrato.</div>
      )}
      <div className="space-y-2">
        {slots.map((s) => (
          <div key={s.id} className="hm-card p-4 text-sm" data-testid={`admin-featured-slot-${s.id}`}>
            <div className="flex flex-wrap items-center gap-3">
              <span className={`text-[10px] uppercase px-2 py-1 rounded ${statusColor(s.status)}`}>{s.status}</span>
              <div className="flex-1 min-w-[200px]">
                <div className="font-mono text-xs text-zinc-400">{s.listing_id}</div>
                <div className="text-xs text-zinc-500">{s.user_email} · €{s.amount} · pi: <span className="font-mono">{(s.payment_intent_id || "").slice(0, 16)}…</span></div>
              </div>
              {s.status === "active" && (
                <div className="text-xs text-right">
                  <div className="text-[#FFBE00] font-bold">Scade {new Date(s.expires_at).toLocaleDateString("it-IT")}</div>
                  <div className="text-zinc-500">Inizio {new Date(s.started_at).toLocaleDateString("it-IT")}</div>
                </div>
              )}
              {s.status === "expired" && (
                <div className="text-[11px] text-zinc-500">Scaduto {new Date(s.expires_at).toLocaleDateString("it-IT")}</div>
              )}
              {s.status === "refund_pending" && (
                <a href={`https://dashboard.stripe.com/payments/${s.payment_intent_id}`} target="_blank" rel="noreferrer" className="text-[10px] uppercase px-2 py-1 rounded bg-red-900 text-white hover:bg-red-700">Rimborsa su Stripe</a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ============================================================ Waitlist Panel
function WaitlistPanel() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true);
    try { setList((await api.get("/admin/featured/waitlist")).data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-3" data-testid="admin-waitlist-panel">
      <div className="flex items-center justify-between">
        <div className="text-sm text-zinc-400"><strong className="text-white">{list.length}</strong> iscritti alla waitlist</div>
        <button onClick={load} className="px-3 py-1.5 text-xs uppercase tracking-wider border border-zinc-700 rounded-md hover:border-white">Aggiorna</button>
      </div>
      {loading && <div className="text-sm text-zinc-500">Caricamento…</div>}
      {!loading && list.length === 0 && (
        <div className="hm-card p-8 text-center text-zinc-500 text-sm">Nessuno in waitlist.</div>
      )}
      <div className="space-y-1">
        {list.map((w) => (
          <div key={w.id} className="hm-card p-3 flex flex-wrap items-center gap-3 text-sm" data-testid={`admin-waitlist-${w.id}`}>
            <div className="flex-1 min-w-[200px]">
              <div className="font-bold">{w.name || "—"}</div>
              <div className="text-xs text-zinc-500">{w.email}</div>
            </div>
            <div className="text-[11px] text-zinc-500">Iscritto {new Date(w.created_at).toLocaleDateString("it-IT")}</div>
            {w.notified_at && (
              <span className="text-[10px] uppercase px-2 py-1 rounded bg-[#22C55E]/20 text-[#22C55E]">Notificato</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}


// ============================================================ Incomplete Subscriptions Panel
function IncompleteSubsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/subscriptions/incomplete");
      setItems(r.data || []);
    } catch {
      toast.error("Errore caricamento");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const runJob = async () => {
    try {
      await api.post("/admin/subscriptions/incomplete/run");
      toast.success("Job eseguito (reminder @6h, cancel @48h)");
      load();
    } catch {
      toast.error("Errore esecuzione job");
    }
  };

  const ageBadge = (h) => {
    if (h == null) return "bg-zinc-800 text-zinc-400";
    if (h >= 48) return "bg-red-950 text-red-400";
    if (h >= 6) return "bg-[#FFBE00]/20 text-[#FFBE00]";
    return "bg-[#22C55E]/20 text-[#22C55E]";
  };

  return (
    <div className="space-y-4" data-testid="admin-incomplete-panel">
      <div className="hm-card p-6">
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-2">· Pagamenti Stripe incompleti</div>
            <p className="text-sm text-zinc-400 max-w-2xl leading-relaxed">
              Utenti che hanno avviato un abbonamento ma non hanno completato il pagamento (3DS chiuso, carta rifiutata, ecc.).
              Il sistema invia automaticamente un'email di reminder dopo <strong className="text-[#FFBE00]">6 ore</strong> e
              cancella la subscription Stripe dopo <strong className="text-red-400">48 ore</strong>.
            </p>
          </div>
          <button onClick={runJob} className="px-4 py-2 rounded-md bg-[#E619A8] text-white text-xs font-bold uppercase tracking-wider hover:bg-[#FFBE00] hover:text-black" data-testid="incomplete-run-job">
            <i className="fas fa-bolt mr-2"></i>Esegui ora
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-12 text-zinc-500">Caricamento…</div>
      ) : items.length === 0 ? (
        <div className="hm-card p-12 text-center">
          <i className="fas fa-circle-check text-4xl text-[#22C55E] mb-3"></i>
          <div className="text-zinc-300 font-bold">Nessun abbonamento incompleto</div>
          <div className="text-xs text-zinc-500 mt-1">Tutti i clienti hanno completato i loro pagamenti, o stanno per essere cancellati automaticamente.</div>
        </div>
      ) : (
        <div className="hm-card p-2">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-xs uppercase tracking-wider text-zinc-500">
                <tr className="border-b border-zinc-800">
                  <th className="text-left p-3">Utente</th>
                  <th className="text-left p-3">Tier</th>
                  <th className="text-left p-3">Avviato</th>
                  <th className="text-left p-3">Età</th>
                  <th className="text-left p-3">Reminder</th>
                  <th className="text-left p-3">Stripe</th>
                </tr>
              </thead>
              <tbody>
                {items.map((u) => {
                  const sub = u.subscription || {};
                  return (
                    <tr key={u.id} className="border-b border-zinc-900 hover:bg-[#0d0d0d]" data-testid={`incomplete-row-${u.id}`}>
                      <td className="p-3">
                        <div className="font-bold">{u.name || "—"}</div>
                        <div className="text-xs text-zinc-500">{u.email}</div>
                      </td>
                      <td className="p-3">
                        <span className="text-xs uppercase px-2 py-1 rounded bg-zinc-900 border border-zinc-800">{sub.tier || "—"} · {sub.cycle || "—"}</span>
                      </td>
                      <td className="p-3 text-xs text-zinc-400">
                        {sub.started_at ? new Date(sub.started_at).toLocaleString("it-IT") : "—"}
                      </td>
                      <td className="p-3">
                        <span className={`text-xs uppercase px-2 py-1 rounded font-bold ${ageBadge(u.age_hours)}`}>
                          {u.age_hours != null ? `${u.age_hours}h` : "—"}
                        </span>
                      </td>
                      <td className="p-3">
                        {u.reminder_sent ? (
                          <span className="text-xs uppercase px-2 py-1 rounded bg-[#22C55E]/20 text-[#22C55E]">Inviato</span>
                        ) : (
                          <span className="text-xs uppercase px-2 py-1 rounded bg-zinc-900 text-zinc-500">In attesa</span>
                        )}
                      </td>
                      <td className="p-3">
                        {sub.stripe_subscription_id ? (
                          <a
                            href={`https://dashboard.stripe.com/subscriptions/${sub.stripe_subscription_id}`}
                            target="_blank"
                            rel="noreferrer"
                            className="text-xs text-[#FFBE00] hover:underline"
                            data-testid={`stripe-link-${u.id}`}
                          >
                            <i className="fab fa-stripe mr-1"></i>Apri
                          </a>
                        ) : (
                          <span className="text-xs text-zinc-600">—</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
